import httpClient from "../../api/httpClient";
import { createWrappedAsyncThunk } from "../createWrappedAsyncThunk";

export const getTeamsByTenant = createWrappedAsyncThunk(
  "team/getTeamsByTenant",
  async ({ tenant_id }) => {
    const { data } = await httpClient.get(`team`, {
      params: {
        tenant_id,
      },
    });
    return { tenant_id, data };
  }
);

export const addEditTeam = createWrappedAsyncThunk(
  "team/addEditTeam",
  async (payload) => {
    return await httpClient.post(`team`, payload);
  }
);
